import React, { useContext, useState } from 'react';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckSquare } from '@fortawesome/free-solid-svg-icons';
import { DaylightContext } from '../DaylightCodeMapper';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../../../context';

const FinalizePracticeButton = () => {
    const dispatch = useDispatch();
    const practiceIsFinalized = useSelector(state => state.daylight.practiceIsFinalized);
    const isLoadingCodes = useSelector(state => state.daylight.isLoadingCodes);
    // TODO: make sure this is working correctly
    const { practiceId } = useContext(DaylightContext);
    
    const [finalizing, setFinalizing] = useState(false);
    const finalizePractice = () => {
        setFinalizing(true);
        if (practiceIsFinalized)
            dispatch(actions.daylight.unfinalizePractice(practiceId))
                .then(() => setFinalizing(false));
        else
            dispatch(actions.daylight.finalizePractice(practiceId))
                .then(() => setFinalizing(false));
    };

    const isIconVisible = !finalizing || practiceIsFinalized;
    const isComplete = practiceIsFinalized;
    const loadingText = isComplete ? 'Marking incomplete...' : 'Completing...';
    return (
        <Button
            color="danger"
            disabled={finalizing || isLoadingCodes}
            onClick={finalizePractice}>
            {finalizing ? (<>{loadingText}</>) : (
                <span>
                    {isComplete ? 'Completed' : 'Complete'}
                    {isIconVisible && (
                        <span>
                            &emsp;
                            <FontAwesomeIcon icon={faCheckSquare} />
                        </span>
                    )}
                </span>
            )}
        </Button>
    );
};

export default FinalizePracticeButton;
